// extracted by mini-css-extract-plugin
export default {"EndGame":"EndGame_EndGame__yesme","list_score":"EndGame_list_score__XGEcZ","option_btn":"EndGame_option_btn__Zh9f9"};